
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 38 38","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#111","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M7.545 12.618L1 17.364V37h36V17.364l-6.545-4.746"}}),_c('path',{attrs:{"d":"M7.545 20.964V1h22.91v19.964M1 17.364L37 37M37 17.364l-18 9.818M14.091 9.182h9.818M14.091 15.727h9.818"}})])])
          )
        }
      }
    